/**
 * useAndroidBack — Bouton retour Android
 *
 * Capacitor 6 expose l'événement 'backButton' directement
 * sur le bridge window.Capacitor sans plugin supplémentaire.
 * Sur les pages racines → minimise l'app.
 * Sur les autres pages → navigate(-1).
 */
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { ROUTES } from '@/router/routes';

// Pages racines où le retour doit minimiser l'app
const ROOT_PAGES = [ROUTES.HOME, ROUTES.AUTH, ROUTES.LANGUAGE, ROUTES.EMAIL_VERIFY];

export function useAndroidBack() {
  const navigate  = useNavigate();
  const location  = useLocation();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const handleBack = (ev: Event) => {
      // Empêcher le comportement par défaut (quitter l'app)
      ev.preventDefault();

      const isRoot = ROOT_PAGES.some(p => location.pathname === p);

      if (isRoot) {
        // Minimiser l'app comme Android le ferait sur l'accueil
        try {
          const cap = (window as any).Capacitor;
          cap?.Plugins?.App?.minimizeApp?.();
        } catch { /* ignore */ }
      } else {
        navigate(-1);
      }
    };

    // Capacitor 6 dispatch 'backButton' sur document
    document.addEventListener('backButton', handleBack, false);
    return () => document.removeEventListener('backButton', handleBack, false);
  }, [navigate, location.pathname]);
}
